import React, { useEffect, useRef, useState } from "react";
import * as image from "../../resources/images";
import ReactPlayer from "react-player";
import { LazyLoadImage } from "react-lazy-load-image-component";
const CharacterContentLeft = ({ charImage, getStartVideo }) => {
    const playerRef = useRef(null);
    const [isPLay, setIsPlay] = useState(true);
    //  console.log('CharacterContentLeft : ', getStartVideo);
    useEffect(() => {
        if (getStartVideo) {
            playerRef.current.seekTo(getStartVideo, "seconds");
        }
    }, [getStartVideo]);
    return (
        <>
            <div className=''>
                <div className='Course_height'>
                    <div className="lessonDtl">
                        <div className="StoryScene">
                            <div className="video_container">
                                {!isPLay && (
                                    <div className="video_icons">
                                        <img src={image.Video_btn} />
                                    </div>
                                )}
                                {charImage.endsWith(".mp4") ? (
                                    <ReactPlayer
                                        ref={playerRef}
                                        width={"100%"}
                                        height="100%"
                                        controls={true}
                                        onPlay={() => setIsPlay(true)}
                                        onPause={() => setIsPlay(false)}
                                        playing={isPLay}
                                        url={charImage}
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: "nodownload",
                                                },
                                            },
                                        }}
                                    />
                                ) : (
                                    <LazyLoadImage
                                        key={charImage}
                                        effect="blur"
                                        placeholderSrc={charImage}
                                        src={charImage}
                                        alt=""
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}
export default CharacterContentLeft;